import { FC } from 'react'
import { Helmet } from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'

type Props = {
  title?: string
  description?: string
  lang?: string
  meta?: Array<any>
  image?: string
}

const Seo: FC<Props> = ({
  description = '',
  lang = 'en',
  meta = [],
  title = '',
  image = '',
}) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            imageUrl
          }
        }
      }
    `
  )

  const defaultTitle = site.siteMetadata?.title
  const defaultDescription = site.siteMetadata?.description
  const defaultImage = site.siteMetadata?.imageUrl

  const metaTitle = title || defaultTitle
  const metaDescription = description || defaultDescription
  const metaImage = image || defaultImage

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={metaTitle}
      defaultTitle={metaTitle}
      titleTemplate={metaTitle ? `%s | Gabbi` : null}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          name: `image`,
          content: metaImage,
        },
        {
          property: `og:title`,
          content: metaTitle,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:image`,
          content: metaImage,
        },
        {
          name: `twitter:card`,
          content: `summary_large_image`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata?.social?.twitter || ``,
        },
        {
          name: `twitter:title`,
          content: metaTitle,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: `facebook-domain-verification`,
          content: '9h7n5ovvjxpxbrif24enl6rb2jn4yn',
        },
      ].concat(meta)}
    />
  )
}

export default Seo
